import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class YarnQualityReferenceService extends BaseReferenceService {
  constructor() {
    super('YarnQualityReference');
  }
}
